module.exports = __webpack_public_path__ + "img/ending_arrow_icon.8fa1c271.svg";